
import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById } from "adminApi/DepartmentApi/Department";
import { validateForm } from "utils/validation";
import { DepartmentRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditDepartmentForm from "./components/EditDepartmentForm";
import fields from "../json/Department.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditDepartment = () => {
    const navigate = useNavigate();
    const { formdata } = fields;
    const { id } = useParams();

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        DepartmentRules
    );

    // Fetch existing data by ID
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, DepartmentRules)
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Department updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch) && <Spinner isSpinner={true} />}
            <EditDepartmentForm
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
            />
        </>
    );
};

export default EditDepartment;
